import { useSelector } from 'react-redux';
import MojitoServices from 'mojito/services';
import MojitoPresentation from 'mojito/presentation';
import MojitoModules from 'mojito/modules';
import MojitoCore from 'mojito/core';
import { isEmpty } from 'mojito/utils';

const { useLocalizedParams } = MojitoPresentation.Hooks;
const { NavigationPathBuilder, types: NavigationTypes } = MojitoPresentation.Base.Navigation;
const { selectTimeZoneGmt } = MojitoServices.UserSettings.selectors;
const SportUtils = MojitoServices.SportsContent.Sports.utils;
const { useMenuContent } = MojitoModules.Common.Hooks;
const CustomRedirect = MojitoModules.CustomRedirect;
const log = MojitoCore.logger.get('SportDefaultPage');

export default function SportDefaultPage(props) {
    const { config } = props.mojitoTools;
    const { sportId } = useLocalizedParams();
    const menusContentInfo = useMenusContentInfo(sportId);

    if (!menusContentInfo || isEmpty(menusContentInfo)) {
        return null;
    }

    const supportedPages = getSupportedPages(config.sports, sportId);
    const defaultPage = getDefaultPageWithContent(supportedPages, menusContentInfo);
    const routingData = getRoutingData(sportId, defaultPage);

    return <CustomRedirect toNav={routingData} isReplace={true} />;
}

function useMenusContentInfo(sportId) {
    const timeZone = useSelector(state => selectTimeZoneGmt(state));

    return useMenuContent(sportId, timeZone);
}

function getDefaultPageWithContent(defaultPages, content) {
    const contentKeys = Object.keys(content);
    const pageTitleWithContent = defaultPages
        .map(page => page.toLowerCase())
        .find(page => !!contentKeys.find(key => key.includes(page) && !!content[key]));

    return pageTitleWithContent?.toLowerCase();
}

function getSupportedPages(pages, sportId) {
    const supportedSubPagesList = pages[sportId];
    if (supportedSubPagesList?.length) {
        return supportedSubPagesList;
    }

    return pages.default;
}

function getRoutingData(sportId, defaultPage) {
    if (
        defaultPage === NavigationTypes.MENUS.HIGHLIGHTS ||
        defaultPage === NavigationTypes.MENUS.COMPETITIONS ||
        defaultPage === NavigationTypes.MENUS.OUTRIGHTS ||
        defaultPage === NavigationTypes.MENUS.MEETINGS ||
        defaultPage === NavigationTypes.MENUS.PRICE_BOOSTS ||
        defaultPage === NavigationTypes.MENUS.PRE_BET_BUILDERS ||
        defaultPage === NavigationTypes.MENUS.MATCHES ||
        defaultPage === NavigationTypes.MENUS.FUTURE
    ) {
        return NavigationPathBuilder.toSportCategory(sportId, defaultPage);
    }
    log.warn(`Sport page not supported: ${defaultPage}`);

    return SportUtils.isRacingSport(sportId)
        ? NavigationPathBuilder.toSportHighlights(sportId)
        : NavigationPathBuilder.toSportCompetitions(sportId);
}
